import { InjectionToken } from '@angular/core';
import { SignalRHubsConnection } from './SignalRHubsConnection';

export const SignalRHubsConnectionToken = new InjectionToken<SignalRHubsConnection>('SignalRHubsConnection');
